export const SEARCH_SIDEBAR_TITLE = 'searchCriteriaResults';
export const isSearchSidebarToggleVisibleByState = (state):boolean => {
  return !state.application.sidebarFirstPartShown;
}

export const SEARCH_RESULTS_SIDEBAR_TITLE = 'resultsResults';
export const isSearchResultsSidebarToggleVisibleByState = (state):boolean => {
  const {
    application: {
      sidebarSecondPartShown,
      isSearchResultDetailsShown
    },
    product: {
      searchResults
    }
  } = state;

  return !sidebarSecondPartShown && !isSearchResultDetailsShown && searchResults && searchResults.totalItems && searchResults.totalItems > 0;
}

export const SEARCH_RESULT_DETAIL_SIDEBAR_TITLE = 'resultSidebar';
